import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';

const demGtnSideNav = {
  id: 'gtn',
  children: [
    // Reconciliation
    {
      id: 'gtnReconMenu',
      displayName: 'Reconciliation',
      role: 'GTN_RECON_VIEW',
      icon: fas.faBalanceScale,
      children: [
        { id: 'gtnDemRecon', displayName: 'Perspective', role: 'GTN_RECON_VIEW', icon: fas.faBalanceScale, route: 'gtn/recon', state: { mode: Mode.PERSPECTIVE } },
        { id: 'gtnReconDashboard', displayName: 'Dashboard', role: 'GTN_RECON_VIEW', icon: fas.faChartLine, route: 'gtn/dashboard/recon' },
      ],
    },

    // Actuals
    {
      id: 'gtnActualsMenu',
      displayName: 'Actuals',
      role: 'GTN_RESERVE_VIEW',
      icon: fas.faClipboard,
      children: [
        { id: 'gtnDemReserve', displayName: 'Reserve', role: 'GTN_RESERVE_VIEW', icon: fas.faClipboard, route: 'gtn/reserve', state: { mode: Mode.PERSPECTIVE } },
        // { id: 'gtnDemMcoPymt', displayName: 'MCO Payments', role: 'GTN_MCO_PYMT_VIEW', icon: fas.faDollarSign, route: 'gtn/mco-pymt', state: { mode: Mode.PERSPECTIVE } },
        // { id: 'gtnDemSbc', displayName: 'Sales by Channel', role: 'GTN_SBC_VIEW', icon: fas.faChartLine, route: 'gtn/sbc', state: { mode: Mode.PERSPECTIVE } },
        { id: 'gtnDemAccrRate', displayName: 'Accrual Rates', role: 'GTN_ACCR_RATE_VIEW', icon: fas.faBadgePercent, route: 'gtn/accr-rate' },
        { id: 'gtnFinanceDashboard', displayName: 'Finance Dashboard', role: 'GTN_VIEW', icon: fas.faChartLine, route: 'gtn/dashboard/finance' },
      ]
    },

    // Forecasting
    { id: 'gtnDemForecast', displayName: 'Forecasts', role: 'GTN_FORECAST_VIEW', icon: fas.faClipboard, route: 'gtn/forecast' }
  ]
};

export default demGtnSideNav;